"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "basic-mians m-flex m-col-top",
    class: {
      "basic-mains--block": _vm.block
    }
  }, [_vm.$scopedSlots.left ? _c("div", {
    staticClass: "sideNav"
  }, [_c("div", {
    staticClass: "side"
  }, [_vm._t("left"), _c("div", {
    staticClass: "m-p-t-12"
  }, [_vm._t("leftSubBtn")], 2)], 2)]) : _vm._e(), _c("div", {
    staticClass: "nain"
  }, [_vm._t("search"), _c("basic-container", [_vm._t("container")], 2)], 2)]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;